"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceDisplay = exports.ReferenceList = void 0;
var React = require("react");
var mobx_react_1 = require("mobx-react");
var generic_1 = require("../generic");
var lists_1 = require("../lib/lists");
var ReferenceList = (function (_super) {
    __extends(ReferenceList, _super);
    function ReferenceList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReferenceList.prototype.onEditReference = function (ref) {
        if (ref.anonymised || ref.backwards) {
            notification(gettext("You cannot edit this reference."));
            return;
        }
        this.props.onEditClick && this.props.onEditClick(ref);
    };
    ReferenceList.prototype.onDeleteReference = function (ref) {
        if (ref.anonymised || ref.backwards) {
            notification(gettext("You cannot delete this reference."));
            return;
        }
        this.props.onDeleteClick && this.props.onDeleteClick(ref);
    };
    ReferenceList.prototype.render = function () {
        var props = this.props;
        var from = {
            "risk": gettext("References from this risk"),
            "control": gettext("References from this control"),
            "action": gettext("References from this action"),
        };
        var to = {
            "risk": gettext("References to this risk"),
            "control": gettext("References to this control"),
            "action": gettext("References to this action"),
        };
        var refs_from = props.references.filter(function (ref) { return !ref.backwards; });
        var refs_to = props.references.filter(function (ref) { return ref.backwards; });
        return (React.createElement("div", null,
            refs_from.length > 0 && (React.createElement("div", null,
                React.createElement("h6", null,
                    React.createElement("i", { className: "fas fa-arrow-right" }),
                    " ",
                    from[props.referredObject]),
                React.createElement(lists_1.ListObjects, { objects: refs_from, getListItemContent: function (ref) { return React.createElement(exports.ReferenceDisplay, { reference: ref }); }, editable: props.editable, deletable: props.deletable, handleEdit: this.onEditReference.bind(this), handleDelete: this.onDeleteReference.bind(this) }))),
            refs_to.length > 0 && (React.createElement("div", null,
                React.createElement("h6", null,
                    React.createElement("i", { className: "fas fa-arrow-left" }),
                    " ",
                    to[props.referredObject]),
                React.createElement(lists_1.ListObjects, { objects: refs_to, getListItemContent: function (ref) { return React.createElement(exports.ReferenceDisplay, { reference: ref }); }, editable: false, deletable: false })))));
    };
    ReferenceList = __decorate([
        mobx_react_1.observer
    ], ReferenceList);
    return ReferenceList;
}(React.Component));
exports.ReferenceList = ReferenceList;
var ReferenceDisplay = function (props) {
    var ref = props.reference;
    var projectLabel = null;
    if (ref.project !== ref.to_project) {
        projectLabel = ref.backwards ? ref.project_name : ref.to_project_name;
    }
    var type = -1;
    if (ref.to_risk != null) {
        type = 1;
    }
    else if (ref.to_control != null) {
        type = 2;
    }
    else if (ref.to_action != null) {
        type = 3;
    }
    var matches = ref.repr.match(/^(.+ #\d+)(.*)/);
    var targetNumber = matches ? matches[1] : null;
    var description = matches ? matches[2].trim() : ref.repr;
    var url = ref.anonymised ? "" : ref.url;
    return (React.createElement("div", { className: "ReferenceList__Reference" },
        projectLabel && React.createElement(React.Fragment, null,
            React.createElement(generic_1.ProjectBox, { value: projectLabel }),
            React.createElement("span", null, " ")),
        targetNumber && React.createElement(generic_1.DomainItemBox, { value: targetNumber, type: type }),
        React.createElement("span", null,
            React.createElement("a", { className: "ReferenceLink", href: url }, description))));
};
exports.ReferenceDisplay = ReferenceDisplay;
